
import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import Statistiche from '@/components/Statistiche.vue'; // @ is an alias to /src

@Component({
  components: {
    HelloWorld,
    Statistiche
  },
})
export default class Home extends Vue {}
